import React from 'react';

/**
 * Topic pill bar + scrollable HTML content area for the active help section.
 * Topic bodies are trusted, in-repo HTML (helpData.js) — never user input — so
 * dangerouslySetInnerHTML is safe here.
 */
export default function HelpContent({ section, activeTopic, onTopicChange }) {
  const currentTopic =
    section.topics.find((t) => t.id === activeTopic) || section.topics[0];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      {/* Topic pills */}
      <div style={{ borderBottom: '1px solid #e5e7eb', padding: 12 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {section.topics.map((topic) => {
            const isActive = currentTopic && topic.id === currentTopic.id;
            return (
              <button
                key={topic.id}
                type="button"
                aria-pressed={isActive}
                onClick={() => onTopicChange(topic.id)}
                style={{
                  padding: '6px 12px',
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 500,
                  border: 'none',
                  cursor: 'pointer',
                  background: isActive ? '#667eea' : '#f3f4f6',
                  color: isActive ? '#fff' : '#6b7280',
                }}
              >
                {topic.title}
              </button>
            );
          })}
        </div>
      </div>

      {/* Body */}
      <div style={{ flex: 1, overflowY: 'auto', padding: 20 }}>
        {currentTopic ? (
          <>
            <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16 }}>
              {currentTopic.title}
            </h3>
            <div
              className="help-content-body"
              style={{ fontSize: 14, color: '#374151', lineHeight: 1.6 }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: currentTopic.body }}
            />
          </>
        ) : (
          <p className="text-muted">Select a topic to read.</p>
        )}
      </div>
    </div>
  );
}
